// Imports ------------------------------------------------------------------->

import {Component, handler, attr} from "../Component";
import {element} from "../CustomElement";
import {icons} from "../../icons/Icons";

const EMAIL_PATTERN = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";
// Private Definitions ------------------------------------------------------->

interface FormInputAttributes extends JSX.HTMLProps {
	name: string;
	placeholder: string;
	type: string;
	errorMessage?: string;
	handleChange: (e: any) => void;
}

// Public Definitions -------------------------------------------------------->

@element("flipp-form-input")
export class FormInput extends Component<FormInputAttributes, {}> {
	@attr name: string;
	@attr placeholder: string;
	@attr type: string;
	@attr errorMessage: string;

	@handler handleChange: (e: any) => void;

	refs: {
		input: HTMLInputElement;
		container: HTMLElement;
		label: HTMLElement;
		errorMsg: HTMLElement;
		eye: HTMLElement;
	};

	shouldShowPassword: boolean;

	onAttach() {
		this.refs.input.addEventListener("input", this.handleChanged);
		if (this.type === "email") {
			this.refs.input.pattern = EMAIL_PATTERN;
		} else if (this.type === "password") {
			this.refs.eye.addEventListener("mousedown", this.showPassword);
			this.refs.eye.addEventListener("touchstart", this.showPassword);
		}
		if (this.refs.input.value.length !== 0) {
			this.refs.input.classList.add("filled");
			this.refs.label.classList.remove("hide");
		}
	}

	onDetach() {
		this.refs.input.removeEventListener("input", this.handleChanged);
		if (this.type === "password") {
			this.refs.eye.removeEventListener("mousedown", this.showPassword);
			this.refs.eye.removeEventListener("touchstart", this.showPassword);
		}
	}

	onAttributeChange(name: string, oldVal: string, newVal: string) {
		super.onAttributeChange(name, oldVal, newVal);

		if (name === "error-message") {
			if (newVal.length === 0) {
				this.refs.container.classList.remove("error");
			}else {
				this.refs.container.classList.add("error");
			}
		}
	}

	render() {
		if (this.type === "password")
			return this.renderPasswordInput();
		else
			return this.renderInput();
	}

	renderInput() {
		return(
			<div ref="container" class="input-container">
				<label ref="label" class="hide" for={this.name}>{this.placeholder}</label>
				<input class="input" autocomplete="nope" ref="input" placeholder={this.placeholder} type={this.type} name={this.name}/>
				<p ref="errorMsg" class="error-msg">{this.errorMessage}</p>
			</div>
		);
	}

	renderPasswordInput() {
		return (
			<div ref="container" class="input-container">
				<div class="password">
					<div class="password-container">
						<label ref="label" class="hide" for={this.name}>{this.placeholder}</label>
						<input class="input" autocomplete="off" ref="input" placeholder={this.placeholder} type={this.type} name={this.name}/>
					</div>
					<span ref="eye" class="eye">{icons.eye}</span>
				</div>
				<p ref="errorMsg" class="error-msg">{this.errorMessage}</p>
			</div>
		);
	}

	private showPassword = () => {
		if (this.type === "password") {
			this.shouldShowPassword = !this.shouldShowPassword;
			if (this.shouldShowPassword) {
				this.refs.input.setAttribute("type", "text");
			} else {
				this.refs.input.setAttribute("type", "password");
			}
		}
	}

	// private hidePassword = () => {
	// 	this.refs.input.setAttribute("type", "password");
	// }

	private handleChanged = (e: any) => {
		this.handlePasswordInputChange(this.refs.input, this.refs.label);
		this.handleChange(e);
	}

	private handlePasswordInputChange = (inputRef: HTMLInputElement, labelRef: HTMLElement) => {
		if (inputRef.value.length === 0) {
			inputRef.classList.remove("filled");
			labelRef.classList.add("hide");
			if (this.type === "password") {
				inputRef.setAttribute("type", "password");
			}
		} else {
			inputRef.classList.add("filled");
			labelRef.classList.remove("hide");
		}
	}
}
